import { Pipe, PipeTransform } from '@angular/core';

export const MAC_ADDRESS_FALLBACK = '—';

@Pipe({
  name: 'macAddress',
  standalone: true,
})
export class MacAddressPipe implements PipeTransform {
  public transform(value: unknown, fallback = MAC_ADDRESS_FALLBACK): string {
    if (typeof value !== 'string') {
      return fallback;
    }

    const normalized = value.replace(/[^0-9a-fA-F]/g, '').toUpperCase();

    if (normalized.length !== 12) {
      return fallback;
    }

    return (normalized.match(/.{2}/g) ?? []).join(':');
  }
}
